import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Workaholic",
  "description": "",
  "published": "2007-12-24T00:00:00.000Z",
  "redirect_from": ["/blog/workaholic/swizec/140"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`There is a popular fable going around wherein somebody teaches values to a group of people, most often this is a philosophy teacher. The teacher takes a glass vase and fills it with large rocks. Then he asks the students whether the vase is full or not. They reply that it is. Then the teacher pours smaller rocks ontop of the large ones and they fill the nook and crannies left in the container. But it still is not full. He can still pour powder sand in it and then it really looks full. But what's this? A glass of beer can still follow before the container is absolutely and completely full.`}</p>
    <p>{`An explanation then follows. `}<em parentName="p">{`The container is your life, the larger stones are important things in life like your spouse, children, friends and so. The smaller ones are less important things like work and money. Finally the glass of beer shows that no matter how full your life may seem there is always room for a relaxing drink.`}</em></p>
    <p>{`However, I believe that, for me at least, the explanation reads differently. The large stones are success, work and money. The smaller represent my hobbies, like writing and things of such ilk and it is only the grain that finally represents family and friends. This, boys and girls, is why I will, ultimately, end up alone in life, married to my job and having projects for my babies.`}</p>
    <p>{`Of course ocasionally a crazy enough girl might like me and think she can divert me from my monstrous ways and make a so called better man of me. And at first it will seem like she is succeeding, my life will revolve almost completely around her and there will be happines and joy, but eventually, as the infatuation and hormones wear off, my priorities will slowly begin to shift back to normality. Perhaps neither will notice it but finally my neglection of her will become too much and she will think that I do not love her anymore or that even if I do she simply does not feel like competing with my work.`}</p>
    <p>{`And so it is that I find it difficult to foresee more than six more months of said kind of happines.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      